import { colors } from "../../../../styles/colors"
import { fonts } from "../../../../styles/fonts";

const modalTitle = {
    color: "rgb(72, 72, 72)",
    fontFamily: fonts.mediumFont,
    fontSize: 16,
    display: "flex",
    gap: 15,
    alignItems: "center",
}

const modalBody = {
    color: "rgb(72, 72, 72)",
    fontFamily: fonts.regularFont,
    fontSize: 16,
    margin: "20px 0px 30px"
}

const modalActions = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start"
}

const buttonStyles = {
    display: "inline",
    fontSize: 14,
    padding: "10px 31px",
    marginTop: "4px"
}

const cancelButtonStyles = {
    color: colors.fuschiaPink,
    fontFamily: fonts.mediumFont,
    fontSize: 16,
    cursor: "pointer"
}

const discardButtonStyles = {
    ...buttonStyles,
    border: "1px solid rgb(255, 46, 99)",
    color: colors.fuschiaPink,
    padding: "10px 21px"
}

const modalConatiner = {
    padding: '25px !important'
}

const primaryActions = {
    cursor: "pointer",
    marginLeft: "auto"
}


export {
    modalTitle,
    modalBody,
    modalActions,
    cancelButtonStyles,
    buttonStyles,
    discardButtonStyles,
    modalConatiner,
    primaryActions
}